import React, { useRef, useEffect } from 'react';
import Loader from 'src/components/loader';
const DownloadModel = ({ isDownloading, downloadProgress, handleConfirmDownload }: any) => {
  const ref = useRef<HTMLButtonElement>(null);

  return (
    <div>
      <div
        className="modal fade"
        id="downloadModel"
        aria-labelledby="downloadModelLabel"
        aria-hidden="true">
        <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
          <div className="modal-content">
            <div className="relative modal-header flex flex-shrink-0 items-center justify-between p-4 rounded-t-md">
              <h5
                className="text-xl font-semibold leading-normal text-center w-full"
                id="downloadModelLabel">
                Confirm Download
              </h5>
              <button
                ref={ref}
                type="button"
                className="dismiss-btn"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body relative py-2 px-10">
              {isDownloading ? (
                <div className="text-center">
                  <Loader />
                  <h3>Please Wait..</h3>
                  <p>Preparing to download ({Math.round(downloadProgress)}%)</p>
                </div>
              ) : (
                <div className="text-center">
                  <p>Are you sure you want to download the data?</p>
                  <button
                    onClick={handleConfirmDownload}
                    className="btn-primary w-auto mt-4 mr-2 borderonly-btn">
                    Download
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadModel;
